import React from 'react';

interface DataContext {
  additionalData: {
    allDownloads: Queries.Download[];
  };
  metaData: any;
}

export default function Downloads({
  additionalData,
  metaData,
}: DataContext): React.JSX.Element {
  const surveryDownloads = additionalData.allDownloads.filter(
    (download: Queries.download) => download.downloads.survey,
  );
  const registerDownloads = additionalData.allDownloads.filter(
    (download: Queries.download) => download.downloads.register,
  );
  const registerArchiveDownloads = additionalData.allDownloads.filter(
    (download: Queries.download) => download.downloads.register_archive,
  );

  return (
    <section className="vl-region">
      <div className="vl-layout">
        <h2 className="vl-title vl-title--h2">
          Download indicatoren uit de burgerbevraging
        </h2>
        <ul>
          {surveryDownloads.map((download: Queries.Download) => (
            <li key={download.id}>
              <a
                href={download.downloads.survey}
                className="vl-link"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className="vl-link__icon vl-link__icon--before vl-icon--large vl-vi vl-vi-download-harddisk"
                  aria-hidden="true"
                />
                {download.name}
              </a>
            </li>
          ))}
        </ul>
        <a
          href={`${metaData.envs.BLOB_STORAGE_BASE_URL}brondata/thema/gemeentestadsmonitor_survey_alledata.xlsx`}
          className="vl-button vl-u-spacer-top"
          vl-button=""
          target="_blank"
          rel="noreferrer"
        >
          <span className="vl-button__label">
            Download alle indicatoren uit de burgerbevraging
          </span>
        </a>
        <h2 className="vl-title vl-title--h2 vl-u-spacer-top--large">
          Download indicatoren uit registerdatabanken
        </h2>
        <ul>
          {registerDownloads.map((download: Queries.Download) => (
            <li key={download.id}>
              <a
                href={download.downloads.register}
                className="vl-link"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className="vl-link__icon vl-link__icon--before vl-icon--large vl-vi vl-vi-download-harddisk"
                  aria-hidden="true"
                />
                {download.name}
              </a>
            </li>
          ))}
        </ul>
        <h2 className="vl-title vl-title--h2 vl-u-spacer-top--large">
          Archief: download indicatoren uit registerdatabanken voor 300
          gemeenten
        </h2>
        <ul>
          {registerArchiveDownloads.map((download: Queries.Download) => (
            <li key={download.id}>
              <a
                href={download.downloads.register_archive}
                className="vl-link"
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className="vl-link__icon vl-link__icon--before vl-icon--large vl-vi vl-vi-download-harddisk"
                  aria-hidden="true"
                />
                {download.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
